import { createSelector } from "reselect";

const selectAlertPage = (state) => state.alertPage;

export const selectAlertPageIsVisible = createSelector(
  selectAlertPage,
  (alertPage) => alertPage.isVisible
);

export const selectAlertPageMessage = createSelector(
  selectAlertPage,
  (alertPage) => alertPage.message
);

export const selectAlertPageFirstBtn = createSelector(
  selectAlertPage,
  (alertPage) => alertPage.firstBtn
);
export const selectAlertPageSecondBtn = createSelector(
  selectAlertPage,
  (alertPage) => alertPage.secondBtn
);

export const selectAlertPageFirstBtnFunc = createSelector(
  selectAlertPage,
  (alertPage) => alertPage.firstBtnFunc
);
export const selectAlertPageSecondBtnFunc = createSelector(
  selectAlertPage,
  (alertPage) => alertPage.secondBtnFunc
);
